import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationOptions } from 'src/app/shared/model/navigation-options.model';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { SearchResultsComponent } from 'src/app/search-results/search-results.component';
import { Constants } from 'src/app/constants/constants';
import { SearchDataService } from 'src/app/service/search-data.service';

@Component({
  selector: 'app-service-provider-dashboard',
  templateUrl: './service-provider-dashboard.component.html',
  styleUrls: ['./service-provider-dashboard.component.scss']
})
export class ServiceProviderDashboardComponent implements OnInit {

  navigationOptions: Array<NavigationOptions> = [];

  //Search result storage variable
  @ViewChild('searchResult') searchResult: SearchResultsComponent;
  searchedLocationList: Array<any>;
  searchedServicePackageList: Array<any>;
  searchedVehicleList: Array<any>;
  selectedSearchItemForView: string;
  showSearchResult: boolean = false;

  constructor(public authService: AuthenticationService, private searchService: SearchDataService) { }

  ngOnInit() {
    this.searchService.searchedData.subscribe(data => {
      this.processSearchResult();
    });
  }

  private processSearchResult() {

    this.searchedVehicleList = this.searchService.getSearchedDataForType(Constants.VEHICLES);
    this.searchedLocationList = this.searchService.getSearchedDataForType(Constants.LOCATIONS);
    this.searchedServicePackageList = this.searchService.getSearchedDataForType(Constants.SERVICE_PACKAGE);
    this.selectedSearchItemForView = null;
    if ((this.searchedVehicleList && this.searchedVehicleList.length > 0) ||
      (this.searchedLocationList && this.searchedLocationList.length > 0) ||
      (this.searchedServicePackageList && this.searchedServicePackageList.length > 0)) {
      this.showSearchResult = true;
    }
    else {
      this.showSearchResult = false;
    }
  }

  ngOnDestroy() {
    this.searchService.resetPreviousSearchResult();
  }

  onSearchItemDetail(searchItem: string) {
    this.selectedSearchItemForView = searchItem;
  }

  onNavSearchClick() {
    this.searchResult.onNavSearchClick();
  }

}